import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import { fa } from "typed-font-awesome";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
export { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { componentToRx } from "app/logic/rx";
import { DireccionComponent } from "./direccion";
import { SucursalMunicipioList } from "./municipios/list";
import { SucursalInformacionComercialList } from "./informacioncomercial/list";
import { TasaImpuestosComponent } from "./../../../../configuraciones/edit/components/impuestos";

type Entity = models.Sucursal;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => Promise<void>;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
    permisos: models.Rol;
}

/**
* Componente para editar un Entity
*/
export class SucursalFormNoRx extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    nombreLLave = (x: Props) => (x.value.NombreLlaveConExtension ? x.value.NombreLlaveConExtension.length : 0) < 20 ? x.value.NombreLlaveConExtension || "" : x.value.NombreLlaveConExtension.substr(0, 15) + "... .key";
    nombreCertificado = (x: Props) => (x.value.NombreCertificadoConExtension ? x.value.NombreCertificadoConExtension.length : 0) < 20 ? x.value.NombreCertificadoConExtension || "" : x.value.NombreCertificadoConExtension.substr(0, 15) + "... .cer";
    nombreCertificadoCompleto = (x: Props) => x.value.NombreCertificadoConExtension || "";
    nombreLLaveCompleto = (x: Props) => x.value.NombreLlaveConExtension || "";

    puedeVerInformacionSAT = (x: Props) => x.permisos.Catalogos.Sucursal.ConsultarInformacionSAT;
    puedeModificarInformacionSAT = (x: Props) => x.permisos.Catalogos.Sucursal.ModificarInformacionSAT;

    puedeVerInformacionTasas = (x: Props) => x.permisos.Catalogos.Sucursal.ConsultarInformacionTasas;
    puedeModificarInformacionTasas = (x: Props) => x.permisos.Catalogos.Sucursal.ModificarInformacionTasas;

    get rules(): validation.Rules<Entity> {
        const iataRule = (value: Entity) => /^[A-Z]{3}$/.test(value.Iata) ? undefined : "Codigo IATA debe de ser de 3 letras";
        return {
            Iata: validation.and(validation.required, iataRule),
            Numero: validation.required,
            Serie: validation.required,
            IdDireccionColonia: validation.required,
            ClaveSistemaContabilidad: validation.required,
            CodigoPostal: validation.required
        };
    }

    private handleOnAgregarFile = async (x: keyof Entity) => {
        const archivo = await kea.upload();
        if (archivo) {
            var aceptedExtensions = x == "Llave" ? ["key"] : ["cer"];
            var keyOfNombre: keyof Entity = x == "Llave" ? "NombreLlaveConExtension" : "NombreCertificadoConExtension";
            const name = archivo.name;
            var nombre = archivo.name.split(".");
            var extension = nombre[nombre.length - 1].toLowerCase();
            if (aceptedExtensions.indexOf(extension) != -1) {
                const datos = await kea.blobToBase64(archivo);
                const tipo = archivo.type;
                const viejo = this.props.value;
                var cambio: Partial<Entity> = { [x]: datos, [keyOfNombre]: name };
                if (this.props.onChange)
                    await this.props.onChange({ ...viejo, ...cambio });
            } else {
                await kea.message("Solo se aceptan archivos .key");
                this.setState({ imagen: "" });
            }
        }
    }

    private handleOnDescargarFile = async (x: keyof Entity) => {
        const mensaje = x == "Llave" ? ".key" : ".cer"
        if (await kea.yesno("¿Descargar archivo " + mensaje + "?")) {
            var value = this.props.value;
            var keyOfNombre: keyof Entity = x == "Llave" ? "NombreLlaveConExtension" : "NombreCertificadoConExtension";
            kea.download(kea.base64ToBlob(value[x] as string, 'application/pkix-cert'), value[keyOfNombre]);
        }
    }

    private onDeleteFile = async (x: keyof Entity) => {
        const mensaje = x == "Llave" ? ".key" : ".cer"
        if (await kea.yesno("Eliminar archivo " + mensaje + "?")) {
            var keyOfNombre: keyof Entity = x == "Llave" ? "NombreLlaveConExtension" : "NombreCertificadoConExtension";
            const viejo = this.props.value;
            var cambio: Partial<Entity> = { [x]: "", [keyOfNombre]: "" };
            await this.props.onChange({ ...viejo, ...cambio });
        }
    }


    render() {
        const { value, onGuardar, nuevo, onChange } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);
        const Municipios = getField(SucursalMunicipioList);
        const InformacionComercial = getField(SucursalInformacionComercialList);
        const Caja = getField(selectores.Caja);

        const nombreCertificado = this.nombreCertificado(this.props);
        const nombreLLave = this.nombreLLave(this.props);
        const nombreCertificadoCompleto = this.nombreCertificadoCompleto(this.props);
        const nombreLLaveCompleto = this.nombreLLaveCompleto(this.props);

        const puedeVerInformacionSAT = this.puedeVerInformacionSAT(this.props);
        const puedeModificarInformacionSAT = this.puedeModificarInformacionSAT(this.props);

        const puedeVerInformacionTasas = this.puedeVerInformacionTasas(this.props);
        const puedeModificarInformacionTasas = this.puedeModificarInformacionTasas(this.props);

        const Tasas = getField(TasaImpuestosComponent);

        const CpSatMunicipioSelector = getField(selectores.CpSatMunicipioSelector);
        const CpSatLocalidadSelector = getField(selectores.CpSatLocalidadSelector);
        const CpSatColoniaSelector = getField(selectores.CpSatColoniaSelector);

        return (
            <div>
                <kea.Title titulo="Editar Sucursal" onRegresar={() => history.go("/catalogos/Sucursal")} />
                {kea.autogrid(6, [
                    <Text field="Iata" />,
                    <Text field="Serie" />,
                    <Number field="Numero" />,
                    <Text field="Nombre" />,
                    <Caja field="IdCajaAdministrativa" label="Caja administrativa" filtro={{ idSucursal: value.IdRegistro }} />,
                    <Check field="EsNueva" label="¿Sucursal nueva?" />,
                    <Text field="ClaveSistemaContabilidad" label="Clave sistema contabilidad" />,
                    <Text field="CodigoPostal" label="Codigo postal (Lugar de expedición):" />,

                    <Number field="DistanciaDefaultEAD" label="Distancia default para EAD (Km)" />,
                ])}
                

                {kea.autogrid(4, [
                    <span>
                        {
                            puedeVerInformacionSAT &&
                            <span>
                                <kea.Button style="success" onClick={() => this.handleOnAgregarFile("Llave")} disabled={!puedeModificarInformacionSAT}  >Agregar .key </kea.Button>
                                <kea.Link style="link" tooltip={nombreLLaveCompleto} onClick={() => this.handleOnDescargarFile("Llave")}>
                                    {nombreLLave}
                                </kea.Link>
                                <kea.IconButton iconClass={fa("trash-o")} style="danger" onClick={() => this.onDeleteFile("Llave")} disabled={!puedeModificarInformacionSAT} tooltip="eliminar .key" />
                            </span>
                        }
                    </span>,
                    <span>
                        {
                            puedeVerInformacionSAT &&
                            <span>
                                <kea.Button style="success" onClick={() => this.handleOnAgregarFile("Certificado")} disabled={!puedeModificarInformacionSAT} >Agregar .cer </kea.Button>
                                <kea.Link style="link" tooltip={nombreCertificadoCompleto} onClick={() => this.handleOnDescargarFile("Certificado")}>
                                    {nombreCertificado}
                                </kea.Link>
                                <kea.IconButton iconClass={fa("trash-o")} style="danger" onClick={() => this.onDeleteFile("Certificado")} disabled={!puedeModificarInformacionSAT} tooltip="eliminar .cer" />
                            </span>
                        }
                    </span>,
                    puedeVerInformacionSAT && <Text field="ContraseñaLlave" label="Contraseña  SAT:" readonly={!puedeModificarInformacionSAT} />,
                ])}

                <br />
                {
                    puedeVerInformacionTasas &&
                    <Tasas field="TasaImpuestos" readonly={!puedeModificarInformacionTasas} />
                }

                <div className="row">
                    <div className="col-md-12">
                        <DireccionComponent value={value} onChange={onChange} />
                    </div>
                </div>

                <Municipios field="Municipios" />
                <InformacionComercial field="InformacionComercial" />

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>);
    }
}

export const SucursalForm = componentToRx(SucursalFormNoRx); 


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/sucursales/edit/form.tsx